export const TEXTAREA_CHARACTER_LIMIT = 60

export const QUANTITY_INPUT = 'QUANTITY_INPUT'

export const MAX_PURCHASE_ADDON_QUANTITY = 99

export const DEFAULT_MAX_QUANTITY = 99
